import type { Router, UrlTree } from '@angular/router';

/** Generic landing for any deep link that fails (deleted, no access, malformed). */
export const CONTENT_UNAVAILABLE_URL = '/unavailable';

export const contentUnavailableTree = (router: Router): UrlTree => router.parseUrl(CONTENT_UNAVAILABLE_URL);

/** `replaceUrl` swaps out the dead link already in history so "Go back" returns to where the user came from. */
export const showContentUnavailable = (router: Router): Promise<boolean> =>
  router.navigateByUrl(CONTENT_UNAVAILABLE_URL, { replaceUrl: true });
